// Display rules for event ratings on the booking site (OTC-23). Used by
// src/components/EventRatings.vue; kept here so tests/event-ratings.test.mjs can load them.
// Console twin: otc-gm-console src/util/ratings.ts (same fill rule).

// Icons that are not in Bootstrap Icons; drawn as tim-icons with a "-fill" variant (nucleo-icons.css).
export const CUSTOM_RATING_ICONS = ['icon-skull', 'icon-witch-hat', 'icon-dragon', 'icon-rocket', 'icon-hourglass']

export function isCustomRatingIcon(icon) {
  return CUSTOM_RATING_ICONS.includes(icon)
}

// Number of icons to draw for an icons rating; 0 for anything unusable.
export function ratingIconCount(rating) {
  const count = Math.floor(Number(rating && rating.max_value))
  return Number.isFinite(count) && count > 0 ? count : 0
}

// How the n-th icon (1-based) is drawn: 3.5 gives full for 1 to 3, half for 4, empty for 5.
export function ratingIconFill(value, n) {
  const v = Number(value) || 0
  if (v >= n) return 'full'
  if (v >= n - 0.5) return 'half'
  return 'empty'
}

// Pill style for a named level: a soft wash and a stronger border of the rating's color.
// The text keeps the card's own color. Unrecognized colors return {} (neutral pill).
export function ratingLevelStyle(color) {
  if (typeof color !== 'string') return {}
  const hex = color.match(/^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/)
  const fn = color.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/)
  let rgb = null
  if (hex) rgb = hex.slice(1, 4).map(part => parseInt(part, 16))
  else if (fn) rgb = fn.slice(1, 4).map(Number)
  if (!rgb) return {}
  return {
    backgroundColor: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.15)`,
    borderColor: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.45)`
  }
}
